module.exports = __webpack_public_path__ + "fonts/ProximaNovaW05-Thin.93838c71.ttf";